module.exports = __webpack_public_path__ + "edee81a9b98691b7e1cc0d2f77cf727d.pdf";